'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { ADPOPCORN_SDK_EVENT_NAME, type AdpopcornSdkEventName, MESSAGE_KEYWORD, subscribeAppEvents } from '@/modules/wello-app';
interface AdpopcornSdkEventData {
  event: AdpopcornSdkEventName;
  payload: unknown;
}
interface UseAdpopcornSdkEventsOptions {
  onClosedOfferWallPage?: (payload: unknown) => void;
  onCompletedCampaign?: (payload: unknown) => void;
  onOfferwallTotalRewardInfo?: (payload: unknown) => void;
  onBridgeTotalRewardInfo?: (payload: unknown) => void;
}
export const useAdpopcornSdkEvents = t0 => {
  const $ = _c(8);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onClosedOfferWallPage,
    onCompletedCampaign,
    onOfferwallTotalRewardInfo,
    onBridgeTotalRewardInfo
  } = t1;
  let t2;
  let t3;
  if ($[2] !== onBridgeTotalRewardInfo || $[3] !== onClosedOfferWallPage || $[4] !== onCompletedCampaign || $[5] !== onOfferwallTotalRewardInfo) {
    t2 = () => subscribeAppEvents(msg => {
      if (msg.type !== MESSAGE_KEYWORD.ADPOPCORN_SDK_EVENT) {
        return;
      }
      const data = msg.data as AdpopcornSdkEventData | undefined;
      if (!data) {
        return;
      }
      bb13: switch (data.event) {
        case ADPOPCORN_SDK_EVENT_NAME.CLOSED_OFFER_WALL_PAGE:
          {
            onClosedOfferWallPage?.(data.payload);
            break bb13;
          }
        case ADPOPCORN_SDK_EVENT_NAME.COMPLETED_CAMPAIGN:
          {
            onCompletedCampaign?.(data.payload);
            break bb13;
          }
        case ADPOPCORN_SDK_EVENT_NAME.OFFERWALL_TOTAL_REWARD_INFO:
          {
            onOfferwallTotalRewardInfo?.(data.payload);
            break bb13;
          }
        case ADPOPCORN_SDK_EVENT_NAME.BRIDGE_TOTAL_REWARD_INFO:
          {
            onBridgeTotalRewardInfo?.(data.payload);
          }
      }
    });
    t3 = [onClosedOfferWallPage, onCompletedCampaign, onOfferwallTotalRewardInfo, onBridgeTotalRewardInfo];
    $[2] = onBridgeTotalRewardInfo;
    $[3] = onClosedOfferWallPage;
    $[4] = onCompletedCampaign;
    $[5] = onOfferwallTotalRewardInfo;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
};